import { z } from 'zod';

export const discountCodeSchema = z.object({
  _id: z.string().optional(),
  code: z.string().min(3, 'Code must be at least 3 characters'),
  ruleId: z.string().min(1, 'Please select a pricing rule'),
  usageLimit: z.preprocess((val) => {
    if (val === '' || val === null || val === undefined) return null;
    const num = Number(val);
    return isNaN(num) ? val : num;
  }, z.number().nullable()),
  usageCount: z.number().default(0),
  active: z.boolean(),
  expiresAt: z.string().min(1, 'Please select an expiration date'),
  archived: z.boolean().optional().default(false),
});

export type DiscountCodeZ = z.infer<typeof discountCodeSchema>;
